var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 18C20.5 25.5 23.8 34.9 31.6 37.4C39.4 39.9 37.7 38.9 51 35C64.3 31.1 68.1 38.4 66.7 44.5C66.7 44.5 70.7 37 75.2 41.2C79.7 45.4 73.6 52.2 69.3 53.9C69.3 53.9 66.6 63.3 65.9 65C70.2754 62.4092 73.7987 58.5969 76.0371 54.0312C78.2755 49.4655 79.1315 44.3455 78.5 39.3C77.6 31.9 77.4 25.3 62.8 19.5C48.2 13.7 23.5 4.59997 21.5 18Z",
    fill: "#E0BF53",
    stroke: "#E0BF53",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7 70.1C44.1447 73.7103 44.2511 77.7181 43 81.4C42.6121 82.199 42.3104 83.037 42.1 83.9C41.6 87.9 49.7 88.4 52.4 87.9C55.0796 87.5538 57.6443 86.5987 59.8977 85.108C62.151 83.6173 64.0332 81.6306 65.4 79.3C65.5039 76.4824 65.8047 73.6756 66.3 70.9C66.4 73.8 66.4 76.8 66.5 79.7C65.2481 82.4178 63.3239 84.7715 60.9092 86.5387C58.4945 88.306 55.6692 89.4284 52.7 89.8C48.9 90.4 41.8 89.8 40.5 85.3C40.1 83.7 41 82.3 41.7 80.9C43.0871 77.4764 43.435 73.72 42.7 70.1Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 31.9C34.7 41.1 33.8 51.1 36.7 60.2C39.6 69.3 44.4 74.1 53.3 70.3C57.5008 68.281 61.2182 65.3822 64.2 61.8C66.2749 59.3482 67.8084 56.4857 68.7 53.4C70.4091 52.1579 71.8966 50.6366 73.1 48.9C74.469 47.4208 75.282 45.5121 75.4 43.5C75.4233 42.7639 75.2263 42.0376 74.8344 41.4141C74.4425 40.7906 73.8734 40.2982 73.2 40C70.6 39.1 68.4 41.5 67 43.5C67.5425 42.5705 68.1792 41.6993 68.9 40.9C71.6 37.9 76 39.3 76.3 43.4C76.5 45.7 75.4 47.8 74.2 49.6C73.0347 51.4808 71.545 53.1398 69.8 54.5L70.1 54C69.2783 57.2636 67.7412 60.3036 65.6 62.9C63.0365 66.1605 59.8815 68.9084 56.3 71C45.7 77 38.5 71.2 35.1 60.7C31.7 50.2 33.8 41 37 31.9Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 58.9C47.3 58.9 51.2 59.7 54.4 58.1C54.3318 59.402 53.8794 60.6547 53.1 61.7C52.3864 62.6713 51.452 63.459 50.374 63.998C49.296 64.537 48.1052 64.8119 46.9 64.8C45.4333 64.8 45.4333 64.7 46.9 64.5C49.9 64 52.7 61.9 53.3 58.9L54 59.4C50.7 60.6 47.1 59.7 43.8 58.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7ec2e6234b50405d156e8a246ebaf3f7.svg";
export { ForwardRef as ReactComponent };